import React from 'react';

function setTagColor(language) {
	if (language === 'ruby') {
		return 'red';
	} else if (language === 'js') {
		return 'yellow';
	} else if (language === 'bootstrap') {
		return 'purple';
	} else if (language === 'semantic ui') {
		return 'green';
	} else if (language === 'react') {
		return 'sky';
	} else if (language === 'tailwind') {
		return 'blue';
	}
}

export default function LanguageTag(props) {
	// console.log('LanguageTag', props);

	return (
		<span
			className={`LanguageTag bg-${setTagColor(
				props.language
			)}-400 inline-block mt-2 m-1 px-2 py-1 rounded-sm`}
		>
			{props.language}
		</span>
	);
}
